import { c as _c } from "react/compiler-runtime";
import React from "react";
import { TestIdEnum } from "../../../tests/types";
import type { ErrorResponse } from "../../types/errors";
interface ErrorMessageProps {
  error: ErrorResponse;
}
export const ErrorMessage = t0 => {
  const $ = _c(3);
  const {
    error
  } = t0;
  let t1;
  if ($[0] !== error.message || $[1] !== error.status) {
    t1 = <div data-testid={TestIdEnum.ErrorMessage} className="flex flex-col items-center justify-center gap-2 bg-white dark:bg-slate-800 rounded-xl p-4 shadow-lg">{error.status === 429 ? <><p className="text-sm font-semibold text-slate-800 dark:text-slate-100 text-center">Zwolnij kowboju!</p><p className="text-sm text-slate-600 dark:text-slate-300 text-center">Strzelasz zapytaniami tak szybko, że aż nam się serwery palą!</p><img src="/images/lucky-luck.gif" alt="Too many requests" className="rounded-xl max-w-full h-auto" /></> : <p className="text-sm text-error-600 dark:text-error-400 text-center">{error.message}</p>}</div>;
    $[0] = error.message;
    $[1] = error.status;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};